import { FC, useMemo } from 'react'
import { FutureLayerUID, FutureLayer } from 'components/features/future/types'
import { FuturePanePreset } from 'components/features/future/FuturePanePreset/FuturePanePreset'
import * as yup from 'yup'
import { useLayerSelector, extendCommonSchema } from 'components/features/future/helpers'
import { FutureWhenInput } from 'components/features/future/FutureWhenInput/FutureWhenInput'
import { FutureFieldSlider } from 'components/features/future/FutureField/FutureFieldSlider'
import { maskCurrencyFromZero } from 'components/atoms/inputs/maskedInput'
import { schemaNumber } from 'schemas/baseSchema'
import { useCollectLayerErrors } from 'components/features/future/hooks/useCollectErrors'
import { ObjectSchema } from 'yup'
import { LayerStatus } from 'components/features/future/LayerStatus/LayerStatus'
import { UpdateMaterialStatus } from 'components/features/future/FutureLayerPast/UpdateMaterialStatus/UpdateMaterialStatus'

const LAYER_SLUG = 'get_married' as const
type LayerSlugType = typeof LAYER_SLUG
type LayerType = Extract<FutureLayer, { slug: LayerSlugType }>

const schemaCreator = extendCommonSchema<LayerSlugType>(yup.object({
  value: schemaNumber,
}) as ObjectSchema<LayerType>)

type FutureLayerPaneGetMarriedProps = {
  uid?: FutureLayerUID
  onCancel: () => void
}

export const FutureLayerPaneGetMarried: FC<FutureLayerPaneGetMarriedProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useLayerSelector<LayerSlugType>(props)

  return (
    <FuturePanePreset<LayerSlugType>
      layer={ layer }
      slug={ LAYER_SLUG }
      name='Get Married'
      icon='heart'
      type='goal'
      schemaCreator={ schemaCreator }
      onCancel={ onCancel }
    >
      <FormFields uid={ uid } />
    </FuturePanePreset>
  )
}

type FormFieldsProps = {
  uid?: FutureLayerUID
}
const FormFields: FC<FormFieldsProps> = (props) => {
  const { uid } = props

  const errors = useCollectLayerErrors<LayerType>()

  const pastCardChild = useMemo(() => (
    <UpdateMaterialStatus />
  ), [])

  const completeChild = useMemo(() => (
    <h1>
      Goal Achieved. Congratulations!
    </h1>
  ), [])

  return (
    <LayerStatus
      uid={ uid || null }
      pastContent={ pastCardChild }
      completeContent={ completeChild }
      type='goal'
    >
      <FutureWhenInput error={ errors.whenField } />

      <FutureFieldSlider
        label='Cost of Wedding'
        name='value'
        mask={ maskCurrencyFromZero }

        error={ errors.value }

        min={ 0 }
        max={ 100000 }
        step={ 100 }
      />

    </LayerStatus>
  )
}
